export { questionCategoryMap, EQuestionCategoryId } from './questionCategoryMap';
export type { QuestionCategoryType, DiagnosisCategory } from './questionCategoryMap';
